var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from "react";
import { BreadcrumbContext } from '../../../../components/Breadcrumb';
import { AuthContext } from "../../../../components/FirebaseAuth";
import { CloudFunctions, FirebaseAuth } from "../../../../components/FirebaseAuth/firebase";
import Alert from "../../../../components/Alert";
import { Form, Field, Input } from "../../../../components/Form";
import Loader from "../../../../components/Loader";
// Ownership transfer moves every account the signed-in user owns, as one unit -- they can
// share a single Stripe Customer (see ownership_transfer.js), so transferring one but not
// another would risk relabeling billing for an account that's staying put.
var TransferOwnership = function () {
    var _a;
    var title = 'Transfer Ownership';
    var _b = useContext(AuthContext), userData = _b.userData, authUser = _b.authUser;
    var setBreadcrumb = useContext(BreadcrumbContext).setBreadcrumb;
    var isOwner = !!(((_a = authUser.user) === null || _a === void 0 ? void 0 : _a.uid) && userData.currentAccount.owner === authUser.user.uid);
    var _c = useState([]), ownedAccounts = _c[0], setOwnedAccounts = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), pendingTransfer = _e[0], setPendingTransfer = _e[1];
    var _f = useState({
        hasError: false,
        error: null,
        value: ""
    }), emailAddress = _f[0], setEmailAddress = _f[1];
    var _g = useState({}), roleSelections = _g[0], setRoleSelections = _g[1];
    var _h = useState(null), error = _h[0], setError = _h[1];
    var _j = useState(false), success = _j[0], setSuccess = _j[1];
    var _k = useState(false), inSubmit = _k[0], setInSubmit = _k[1];
    var _l = useState(false), cancelling = _l[0], setCancelling = _l[1];
    useEffect(function () {
        setBreadcrumb([
            {
                to: "/",
                text: "Home",
                active: false
            },
            {
                to: "/account/" + userData.currentAccount.id + "/",
                text: userData.currentAccount.name + " (".concat(userData.currentAccount.id, ")"),
                active: false
            },
            {
                to: null,
                text: title,
                active: true
            }
        ]);
        if (!isOwner) {
            setLoading(false);
            return;
        }
        var isSubscribed = true;
        var load = function () { return __awaiter(void 0, void 0, void 0, function () {
            var user, accountsRef, snapshot, accounts, defaultRoles, getPending, pendingRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = FirebaseAuth.auth().currentUser;
                        if (user === null) {
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        accountsRef = FirebaseAuth.firestore().collection('accounts');
                        return [4 /*yield*/, accountsRef.where('owner', '==', user.uid).get()];
                    case 1:
                        snapshot = _a.sent();
                        accounts = [];
                        defaultRoles = {};
                        snapshot.forEach(function (doc) {
                            var _a;
                            accounts.push({
                                id: doc.id,
                                name: doc.data().name,
                                multipleRoles: ((_a = doc.data().features) === null || _a === void 0 ? void 0 : _a.multiple_roles) === true
                            });
                            defaultRoles[doc.id] = 'none';
                        });
                        getPending = CloudFunctions.httpsCallable('oncall');
                        return [4 /*yield*/, getPending({ name: "getMyPendingOwnershipTransfer", data: {} })];
                    case 2:
                        pendingRes = _a.sent();
                        if (isSubscribed) {
                            setOwnedAccounts(accounts);
                            setRoleSelections(defaultRoles);
                            setPendingTransfer(pendingRes.data.transfer);
                            setLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        load().catch(function (err) {
            if (isSubscribed) {
                setError(err.message);
                setLoading(false);
            }
        });
        return function () { isSubscribed = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData, setBreadcrumb]);
    return (_jsx("div", { className: "container-fluid", children: _jsx("div", { className: "animated fadeIn", children: _jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: title }), _jsx("div", { className: "card-body", children: !isOwner ? (_jsx(Alert, { type: "danger", message: "Access Denied. You are not the account owner.", dismissible: false })) : loading ? (_jsx(Loader, { text: "Loading your accounts..." })) : success ? (_jsx(Alert, { type: "success", message: "Transfer request sent. The new owner must accept it by email before anything changes.", dismissible: false })) : pendingTransfer !== null ? (_jsxs(_Fragment, { children: [error !== null &&
                                    _jsx(Alert, { type: "danger", message: error, dismissible: true, onDismiss: function () { return setError(null); } }), _jsxs("p", { children: ["You have a pending ownership transfer request affecting ", pendingTransfer.accountIds.length, " account(s), sent on ", new Date(pendingTransfer.requestedAt).toLocaleString(), ". Nothing changes until the new owner accepts it."] }), _jsxs("button", { className: "btn btn-danger", disabled: cancelling, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var cancelTransfer, err_1;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    setCancelling(true);
                                                    setError(null);
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([1, 3, , 4]);
                                                    cancelTransfer = CloudFunctions.httpsCallable('oncall');
                                                    return [4 /*yield*/, cancelTransfer({ name: "cancelOwnershipTransfer", data: { transferId: pendingTransfer.id } })];
                                                case 2:
                                                    _a.sent();
                                                    setPendingTransfer(null);
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    err_1 = _a.sent();
                                                    setError(err_1.message);
                                                    return [3 /*break*/, 4];
                                                case 4:
                                                    setCancelling(false);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }, children: [cancelling && _jsx(Loader, {}), " Cancel Transfer Request"] })] })) : (_jsxs(_Fragment, { children: [error !== null &&
                                    _jsx(Alert, { type: "danger", message: error, dismissible: true, onDismiss: function () { return setError(null); } }), _jsxs("p", { children: ["Transferring ownership moves ", _jsxs("strong", { children: ["all ", ownedAccounts.length, " account(s)"] }), " you own to the new owner at once -- it can't be done for just one account, since they may share the same billing identity. The new owner must accept this by email before anything changes."] }), _jsxs(Form, { handleSubmit: function (e) {
                                        e.preventDefault();
                                        setError(null);
                                        setInSubmit(true);
                                        var requestTransfer = CloudFunctions.httpsCallable('oncall');
                                        requestTransfer({
                                            name: "requestOwnershipTransfer",
                                            data: {
                                                newOwnerEmail: emailAddress.value,
                                                roleSelections: roleSelections
                                            }
                                        }).then(function () {
                                            setInSubmit(false);
                                            setSuccess(true);
                                        }).catch(function (err) {
                                            setInSubmit(false);
                                            setError(err.message);
                                        });
                                    }, disabled: emailAddress.hasError || emailAddress.value === "" || inSubmit, submitBtnStyle: "danger", inSubmit: inSubmit, enableDefaultButtons: true, backToUrl: "/account/" + userData.currentAccount.id + "/", children: [_jsx(Field, { label: "New Owner's Email", children: _jsx(Input, { type: "email", name: "new-owner-email", hasError: emailAddress.hasError, error: emailAddress.error, minLen: 5, maxLen: 50, required: true, validRegex: "^[a-zA-Z0-9-_+\\.]*@[a-zA-Z0-9-_\\.]*\\.[a-zA-Z0-9-_\\.]*$", changeHandler: setEmailAddress }) }), ownedAccounts.length > 0 && (_jsx(Field, { label: "Keep Access", description: "Choose what access (if any) you'd like to keep for yourself on each account after the transfer.", children: _jsxs("table", { className: "table table-sm", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Account" }), _jsx("th", { children: "Your Role After Transfer" })] }) }), _jsx("tbody", { children: ownedAccounts.map(function (a) { return (_jsxs("tr", { children: [_jsx("td", { children: a.name }), _jsx("td", { children: a.multipleRoles ? (_jsxs("select", { className: "form-control", defaultValue: "none", onChange: function (e) {
                                                                            var role = e.target.value;
                                                                            setRoleSelections(function (prev) {
                                                                                var _a;
                                                                                return (__assign(__assign({}, prev), (_a = {}, _a[a.id] = role, _a)));
                                                                            });
                                                                        }, children: [_jsx("option", { value: "none", children: "No access" }), _jsx("option", { value: "registrar", children: "registrar" }), _jsx("option", { value: "financier", children: "financier" }), _jsx("option", { value: "admin", children: "admin" })] })) : (_jsx("span", { className: "text-muted", children: "No access -- plan doesn't support keeping a role" })) })] }, a.id)); }) })] }) }))] })] })) })] }) }) }));
};
export default TransferOwnership;
